import live from './live';
import uploader from './uploader';
import qtClient from 'lib/qt-client';

if (typeof window !== 'undefined') {
  const __roomLib = {
    live,
    uploader,
    qtClient,
  };
  Object.assign(window, {
    __roomLib,
  });
}

export { live, uploader, qtClient };
